import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestfulService } from '../rest/restful';
import { RestProvider, RestService } from '../rest/rest.service';

@Injectable()
export class ReadmeService extends RestfulService<Models.Readme> {

  constructor(private restService: RestService) {
    super(Models.Readme);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('readmes');
  }

}
